export default __webpack_public_path__ + "static/media/longchamp2.7e934b4b.jpg";